import React, { CSSProperties, FC, useCallback, useEffect, useRef, useState } from 'react';

export interface CompareImagePairProps {
  beforeSrc: string;
  afterSrc: string;
}

const overlayBase: CSSProperties = {
  position: 'absolute',
  display: 'block',
  top: 0,
  left: 0,
  width: '100%',
};

const beforeStyle: CSSProperties = {
  ...overlayBase,
  height: 'auto',
  zIndex: 2,
  clipPath: 'polygon(0% 0%,50% 0%,50% 100%,0% 100%)',
};

const afterStyle: CSSProperties = {
  ...overlayBase,
  height: '100%',
  objectFit: 'cover',
  zIndex: 1,
};

export const CompareImagePair: FC<CompareImagePairProps> = ({ beforeSrc, afterSrc }) => {
  const beforeRef = useRef<HTMLImageElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  // Portal CSS forces both images to position:absolute, so the container height must be set from the first image.
  const syncHeight = useCallback(() => {
    const measured = beforeRef.current?.offsetHeight;
    if (measured) {
      setHeight(measured);
    }
  }, []);

  useEffect(() => {
    const image = beforeRef.current;
    if (!image || typeof ResizeObserver === 'undefined') {
      return undefined;
    }
    const observer = new ResizeObserver(syncHeight);
    observer.observe(image);
    return () => observer.disconnect();
  }, [syncHeight]);

  return (
    <div className='twentytwenty-wrapper twentytwenty-horizontal'>
      <div
        data-testid='compare-container'
        className='module__media twentytwenty-container'
        style={{ position: 'relative', height }}>
        <img ref={beforeRef} src={`${beforeSrc}?dimension=1200x1200`} alt='' style={beforeStyle} onLoad={syncHeight} />
        <img src={`${afterSrc}?dimension=1200x1200`} alt='' style={afterStyle} />
      </div>
    </div>
  );
};

export default CompareImagePair;
